<template>
<div>
  <v-card></v-card>
</div>
</template>

<script>
export default {
  name: "UserInfoCard"
}
</script>

<style scoped>

</style>
